<template>
  <div id="app">
    <App_nav></App_nav>
    <div class="container mt-2">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import App_nav from "./components/app_nav";

export default {
  name: 'App',
  components: {
    App_nav,
  }
}
</script>

<style>

</style>
